import { Button } from '@/components/ui/button';
import { Loader2, Trash2, X } from 'lucide-react';

interface BulkActionBarProps {
  count: number;
  onDelete: () => void;
  onCancel: () => void;
  isDeleting?: boolean;
}

export function BulkActionBar({ count, onDelete, onCancel, isDeleting }: BulkActionBarProps) {
  if (count === 0) return null;

  return (
    <div className="sticky bottom-0 z-10 border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 p-3 flex items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <span className="text-sm font-medium">
          {count} item{count !== 1 ? 's' : ''} selected
        </span>
        <Button variant="ghost" size="sm" onClick={onCancel} disabled={isDeleting}>
          <X className="h-4 w-4 mr-1" />
          Clear
        </Button>
      </div>
      <Button variant="destructive" size="sm" onClick={onDelete} disabled={isDeleting}>
        {isDeleting ? (
          <Loader2 className="h-4 w-4 mr-1 animate-spin" />
        ) : (
          <Trash2 className="h-4 w-4 mr-1" />
        )}
        Delete Selected
      </Button>
    </div>
  );
}
